
<!-- BENEFITS / DETAILS -->
<section class="container-fluid min-height-container py-5 bg-gray-600">
  <div class="container">
    <div class="row">
      <div class="col-md-10 offset-md-1">

        <hr class="border-gray-900 opacity-100 mb-5" />

        <h2 class="text-white display-6 fw-bold mb-3">Built for Providers, Backed by Compliance</h2>

        <div class="row g-4">
          <div class="col-md-6">
            <div class="h-100 p-4 bg-gray-500 text-white border border-gray-900 rounded-3">
              <h3 class="fs-3 fw-bold">Keep Patients Coming Back</h3>
              <p class="fs-5 mb-0">
                Offering discounts helps reduce no-shows and builds long-term loyalty—leading to better outcomes for your
                patients and reliable growth for your practice. When care is affordable, patients return.
              </p>
            </div>
          </div>

          <div class="col-md-6">
            <div class="h-100 p-4 bg-gray-500 text-white border border-gray-900 rounded-3">
              <h3 class="fs-3 fw-bold">Set Up in Minutes</h3>
              <p class="fs-5 mb-0">
                No complicated setup, no special software. Just <a class="text-center text-black" routerLink="/providers" fragment="joinNow">join</a> our provider network and start offering discounts instantly.
                It's that simple.
              </p>
            </div>
          </div>

          <div class="col-md-6">
            <div class="h-100 p-4 bg-gray-500 text-white border border-gray-900 rounded-3">
              <h3 class="fs-3 fw-bold">Completely Free for Providers</h3>
              <p class="fs-5 mb-0">
                We believe in supporting practices, not charging them. Family Health Advantage is 100% free for providers—no
                hidden fees, no subscriptions.
              </p>
            </div>
          </div>

          <div class="col-md-6">
            <div class="h-100 p-4 bg-gray-500 text-white border border-gray-900 rounded-3">
              <h3 class="fs-3 fw-bold">Expert Support &amp; Free Training</h3>
              <p class="fs-5 mb-0">
                You're never on your own. Get ongoing support, best-practice guidance, and free training to help you get the most
                from our platform.
              </p>
            </div>
          </div>
        </div>

        <hr class="border-gray-900 opacity-100 my-5" />

        <h2 class="text-white display-6 fw-bold mb-3">Grow Your Practice—The Smart Way</h2>
        <p class="text-white fs-5 mb-0">
          In a competitive healthcare landscape, offering cost-effective care isn’t just smart—it’s strategic. With Family Health
          Advantage, you’ll stand out, attract more patients, and build long-term success without adding complexity to your
          operations.
        </p>

        <hr class="border-gray-900 opacity-100 my-5" />

        <h2 class="text-white display-6 fw-bold mb-3">Ready to See How It Works?</h2>
        <p class="text-white fs-5">
          Getting started is quick, easy, and completely online. Join providers already offering compliant, affordable care—with
          zero risk and zero hassle. Sign up today with our simple, step-by-step onboarding process and start offering patient
          discounts right away.
        </p>

      </div>
    </div>
  </div>
</section>